<template>

    <v-flex>
        <p class="input-label my-1">{{ label }}</p>

        <div v-if="val && val.file">
            <slot name="display"></slot>
        </div>

        <!-- logo uploader -->
        <div v-else>
            <LogoUploader v-bind="$attrs" :editedImage="val" @logoValidated="logoValidated" @logoCanceled="logoCanceled" />
        </div>
    </v-flex>

</template>

<script>

import LogoUploader from '../common/LogoUploader'

export default {
  name: 'UploadInput',
  components: {
    LogoUploader
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      default: null
    }
  },
  data () {
    return {
      uploaderToggled: false
    }
  },
  methods: {
    logoValidated (file, fileName) {
      this.val = {
        file: file,
        fileName: fileName
      }
    },
    logoCanceled () {
      this.val = null
    }
  },
  computed: {
    val: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/forms/UploadInput.vue